import { z } from "zod";
import { zBackdrop } from "./backdrops";
import type { PerformanceBundle } from "./performances";

/**
 * How a backdrop hides its puppets' lower bodies (they are waist-up hand puppets): "bottom-stage" (close foreground
 * along the bottom edge; the cast rise from below the picture), "rail" (a low wall, fence or counter across the
 * bottom; the cast stand behind its flat top) or "platforms" (two or three flat-topped stumps, stone slabs or crates
 * near the sides).
 */
export const zPuppetStaging = z.enum(["bottom-stage", "rail", "platforms"]);
export type PuppetStaging = z.infer<typeof zPuppetStaging>;

const backdrop = zBackdrop;

/** A malformed location must never make a saved story's renderer unusable. */
export function validateStoryEditorBackdrops(bundle: PerformanceBundle): void {
  for (const [id, value] of Object.entries(bundle.performance.backdrops ?? {})) {
    const result = backdrop.safeParse(value);
    if (!result.success)
      throw new Error(
        `Backdrop ${id}: ${result.error.issues.map((i) => `${i.path.join(".")} ${i.message}`).join("; ")}`
      );
    const ids = result.data.locations?.map((l) => l.id) ?? [];
    if (new Set(ids).size !== ids.length) throw new Error(`Backdrop ${id} has duplicate location ids.`);
  }
}
